<template>
  <div>
    <!--coupon manager vue2 template-->
    <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
      size="mini"
    >
      <el-form-item label="优惠券名称">
        <el-input v-model="searchForm.couponName" clearable></el-input>
      </el-form-item>
      <el-form-item label="优惠券类型">
        <el-select v-model="searchForm.couponType" clearable filterable>
          <el-option
            v-for="item in couponTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消费方式">
        <el-select v-model="searchForm.consumeType" clearable filterable>
          <el-option
            v-for="item in couponConsumeTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="领取方式">
        <el-select v-model="searchForm.receiveType" clearable filterable>
          <el-option
            v-for="item in couponReceiveTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="有效期类型">
        <el-select v-model="searchForm.validityType" clearable filterable>
          <el-option
            v-for="item in couponValidityTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="优惠券状态">
        <el-select v-model="searchForm.status" clearable filterable>
          <el-option
            v-for="item in couponStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <!--buttons-->
    <div style="margin-bottom: 10px">
      <el-button size="mini" @click="gotoSubscriberCoupon"
        >会员优惠券</el-button
      >
    </div>

    <!--element-ui table page-->
    <el-table
      :data="couponList"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
    >
      <el-table-column
        prop="id"
        label="编号"
        width="50"
        center
      ></el-table-column>
      <el-table-column prop="title" label="优惠券名称"></el-table-column>
      <el-table-column prop="typeName" column-key="type" label="优惠券类型">
      </el-table-column>
      <el-table-column prop="consumeTypeName" label="消费方式">
      </el-table-column>
      <el-table-column prop="receiveTypeName" label="领取方式">
      </el-table-column>
      <el-table-column prop="validityTypeName" label="有效期类型">
      </el-table-column>
      <el-table-column prop="amount" label="优惠券面额"></el-table-column>
      <el-table-column prop="total" label="发放总量"></el-table-column>
      <el-table-column prop="received" label="已领取数量"></el-table-column>
      <el-table-column prop="statusName" label="状态"> </el-table-column>
      <el-table-column prop="created" label="创建时间"></el-table-column>
      <el-table-column prop="modified" label="更新时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <!--link链接-->
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="openCouponHistory(scope.row)"
          >
            领取记录</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="publishCoupon(scope.row)"
          >
            发放优惠券</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="generateCoupon(scope.row)"
          >
            生成记录</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleEdit(scope.row)"
            >编辑</el-link
          >
          <!-- <el-divider direction="vertical"></el-divider>
          <el-link
            type="danger"
            :underline="false"
            size="mini"
            @click="handleDelete(scope.row)"
            >删除</el-link
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>

    <coupon-history ref="couponHistoryRef"></coupon-history>
    <publish-coupon ref="publishCouponRef" @close="loadPage"></publish-coupon>
    <generate-coupon ref="generateCouponRef"></generate-coupon>
  </div>
</template>

<script>
import {
  couponStatusApi,
  couponTypeApi,
  couponValidityApi,
  couponReceiveTypeApi,
  couponConsumeTypeApi,
  loadCouponPageApi,
  deleteCouponApi
} from "@/api/coupon";
import CouponHistory from "./components/history.vue";
import PublishCoupon from "./components/publishCoupon.vue";
import GenerateCoupon from "./components/generateCoupon.vue";
export default {
  components: {
    CouponHistory,
    PublishCoupon,
    GenerateCoupon
  },
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // 优惠券有效期类型
      couponValidityTypeOptions: [],
      // 优惠券类型
      couponTypeOptions: [],
      // 优惠券领取方式
      couponReceiveTypeOptions: [],
      // 优惠券状态
      couponStatusOptions: [],
      // 优惠券消费方式
      couponConsumeTypeOptions: [],
      couponList: [],
      loading: false
    };
  },
  created() {
    this.getBizCouponTypeOptions();
    this.getBizCouponValidityTypeOptions();
    this.getBizCouponReceiveTypeOptions();
    this.getBizCouponStatusOptions();
    this.getBizCouponConsumeTypeOptions();
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    loadPage(page) {
      if (page) {
        this.searchForm.pageNum = page;
      }
      this.loading = true;
      loadCouponPageApi(this.searchForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.couponList = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 新增
     */
    handleAdd() {
      this.$router.push({
        path: "/biz_coupon_edit"
      });
    },
    handleEdit(row) {
      this.$router.push({
        path: "/biz_coupon_edit",
        query: {
          id: row.id
        }
      });
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除该优惠券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          deleteCouponApi(row.id)
            .then(resp => {
              if (resp.data.status == 100) {
                this.$message({
                  message: resp.data.message,
                  type: "success"
                });
                this.loadPage();
              } else {
                this.$message({
                  message: resp.data.message,
                  type: "error"
                });
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    getBizCouponTypeOptions() {
      let _self = this;
      couponTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponTypeOptions = resp.data.results;
        }
      });
    },
    getBizCouponValidityTypeOptions() {
      let _self = this;
      couponValidityApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponValidityTypeOptions = resp.data.results;
        }
      });
    },
    getBizCouponReceiveTypeOptions() {
      let _self = this;
      couponReceiveTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponReceiveTypeOptions = resp.data.results;
        }
      });
    },
    getBizCouponStatusOptions() {
      let _self = this;
      couponStatusApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponStatusOptions = resp.data.results;
        }
      });
    },
    getBizCouponConsumeTypeOptions() {
      let _self = this;
      couponConsumeTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponConsumeTypeOptions = resp.data.results;
        }
      });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.loadPage();
    },
    gotoSubscriberCoupon() {
      this.$router.push({
        path: "/subscriberCouponHistory"
      });
    },
    openCouponHistory(row) {
      this.$refs.couponHistoryRef.openDialog(row);
    },
    publishCoupon(row) {
      this.$refs.publishCouponRef.open(row);
    },
    generateCoupon(row) {
      this.$refs.generateCouponRef.open(row);
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// index.vue?2763dba3